import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import AuditList from '../components/AuditList'
import { getActiveAudits } from '../actions/searchAuditsAction'

import '../style/oversight-mini-gear.scss'

const OversightMiniGear = ({ user, activeAudits, getActiveAudits }) => {
  useEffect(() => {
    getActiveAudits && getActiveAudits()
  }, [getActiveAudits])

  if (activeAudits.fetching || !activeAudits.list) {
    return <LgyLoadingIcon className='oversight-mini-gear' />
  } else {
    return <div className='oversight-mini-gear'>
      <h3>Oversight</h3>
      {user.authorizations.some(auth => auth === 'View Active Audits Table') && <AuditList {...activeAudits} minigear={true} />}
      <LgyLink to='/lgyhub/oversight/search'>Search Audits</LgyLink>
      <br />
      {user.authorizations.some(auth => auth === 'Create QA Audit File' || auth === 'Create MU Audit File') &&
        <LgyLink to='/lgyhub/oversight/create'>Create New Audit</LgyLink>}
    </div>
  }
}

const mapStateToProps = state => ({
  activeAudits: state.oversight.activeAudits
})

const mapDispatchToProps = { getActiveAudits }

export default connect(mapStateToProps, mapDispatchToProps)(OversightMiniGear)